import { render } from "./startCommande.vue?vue&type=template&id=55e6ea21&scoped=true"
import script from "./startCommande.vue?vue&type=script&lang=js"
export * from "./startCommande.vue?vue&type=script&lang=js"

import "./startCommande.vue?vue&type=style&index=0&id=55e6ea21&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e6ea21"]])

export default __exports__